export default {
  locations (state, getters, rootState) {
    return state.locations
  },
  accounts (state, getters, rootState) {
    return state.accounts
  },
  allServices (state, getters, rootState) {
    return state.allServices
  },
  bookers (state, getters, rootState) {
    return state.bookers
  },
  destinationAccessorials (state, getters, rootState) {
    return state.destinationAccessorials
  },
  metrics (state, getters, rootState) {
    return state.metrics
  },
  originAccessorials (state, getters, rootState) {
    return state.originAccessorials
  },
  prefs (state, getters, rootState) {
    return state.preferences
  },
  rate (state, getters, rootState) {
    return state.rate
  },
  quotes (state, getters, rootState) {
    return state.quotes
  },
  providersCodeToName (state, getters, rootState) {
    return !state.providers.length ? {} : state.providers.reduce((val, {code, name}) => {
      val[code] = name
      return val
    }, {})
  },
  financeItems (state, getters, rootState) {
    return state.financeItems
  }
}



// WEBPACK FOOTER //
// ./src/modules/quote/store/getters.js